import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import styles from './screen-reader-only.styles.scss';

export const SCREEN_READER_ONLY_TAG = 'platfrom-screen-reader-only' as const;

/**
 * Simple web component used to visually hide content
 * while leaving it visibile to screen readers.
 */
@customElement(SCREEN_READER_ONLY_TAG)
export class SpogScreenReaderOnly extends LitElement {
  static override styles = [styles];

  override render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [SCREEN_READER_ONLY_TAG]: SpogScreenReaderOnly;
  }
}
